import { CgSpinnerTwoAlt } from "react-icons/cg"
import { LoadingDiv } from "./styled"

export const Loading = () => {
    return (
        <LoadingDiv >
            <CgSpinnerTwoAlt />
        </LoadingDiv>
    )
}